import '../scss/customer.scss';
import '../components/form-addresses';
import '../utils/register';
import { $Qll } from '../utils/query-selector';
import { togglePassword } from '../utils/toggle-password';
import { recoverToggle } from '../utils/recover-password';
const eyeIcon = $Qll('.form__textfield--password .form__textfield__icon');

if (eyeIcon) togglePassword(eyeIcon);
recoverToggle();
